import { NgModule } from '@angular/core';

import { AddAuthTokenPipe } from './add-auth-token.pipe';
import { FormatDatePipe } from './format-date.pipe';
import { GetSafeImageUrlPipe } from './get-safe-image-url-pipe';

const pipes = [AddAuthTokenPipe, FormatDatePipe, GetSafeImageUrlPipe];

@NgModule({
    declarations: pipes,
    exports: pipes
})
export class PipesModule {}
